/** @jsxImportSource @emotion/react */

import Typography from '@mui/material/Typography'
import { useState } from 'react'
import TabsNavigation from 'components/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import * as classes from './styles'
import { VideoContentTabs } from './consts'
import { DescriptionContent } from './DescriptionContent/DescriptionContent'

const tabs = Object.values(VideoContentTabs).map((item) => ({ id: item, title: item }))

export const VideoContent = () => {
  const [activeTab, setActiveTab] = useState<TabsItem>(tabs[0])

  const renderTab = () => {
    const { title } = activeTab

    if (title === VideoContentTabs.DESCRIPTION) {
      return <DescriptionContent />
    }
  }

  return (
    <div css={classes.container}>
      <Typography variant="title3" css={classes.title}>
        Video Content
      </Typography>

      <TabsNavigation<TabsItem> tabs={tabs} value={activeTab} onChange={setActiveTab} css={classes.tabs} />

      {renderTab()}
    </div>
  )
}
